export default Object.freeze({
    Minute: 0,
    Hour: 1,
});
